module.exports = __webpack_public_path__ + "f411176d446cf82e063b518590077630.jpg";